import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ToastProvider, ConfirmProvider } from './ui';
import ErrorBoundary from './components/ErrorBoundary';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Portfolio from './pages/Portfolio';
import Users from './pages/Users';
import AuditLogs from './pages/AuditLogs';
import Settings from './pages/Settings';
import Brokers from './pages/Brokers';
import BrokerInvestors from './pages/BrokerInvestors';
import Payouts from './pages/Payouts';
import Expenses from './pages/Expenses';
import AdminProfit from './pages/AdminProfit';
import PayoutAlerts from './pages/PayoutAlerts';
import Investors from './pages/Investors';
import TransactionHistory from './pages/TransactionHistory';
import InvestorROI from './pages/InvestorROI';
import MinuteROIAnalytics from './pages/MinuteROIAnalytics';
import ProfitAllocation from './pages/ProfitAllocation';
import AdminROIDebug from './pages/AdminROIDebug';
import Layout from './components/Layout';

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <ToastProvider>
          <ConfirmProvider>
            <AuthProvider>
              <NotificationProvider>
                <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ErrorBoundary>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/portfolio" element={<Portfolio />} />
                          <Route path="/roi" element={<InvestorROI />} />
                          <Route path="/analytics" element={<MinuteROIAnalytics />} />
                          <Route path="/users" element={<Users />} />
                          <Route path="/logs" element={<AuditLogs />} />
                          <Route path="/brokers" element={<Brokers />} />
                          <Route path="/brokers/:brokerId/investors" element={<BrokerInvestors />} />
                          <Route path="/broker-investors" element={<BrokerInvestors />} />
                          <Route path="/payouts" element={<Payouts />} />
                          <Route path="/expenses" element={<Expenses />} />
                          <Route path="/admin-profit" element={<AdminProfit />} />
                          <Route path="/payout-alerts" element={<PayoutAlerts />} />
                          <Route path="/investors" element={<Investors />} />
                          <Route path="/transaction-history" element={<TransactionHistory />} />
                          <Route path="/profit-allocation" element={<ProfitAllocation />} />
                          <Route
                            path="/admin-roi-debug"
                            element={(
                              <PrivateRoute requiredRole={['admin']}>
                                <AdminROIDebug />
                              </PrivateRoute>
                            )}
                          />
                          <Route path="/settings" element={<Settings />} />
                          <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                      </ErrorBoundary>
                    </Layout>
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
              </NotificationProvider>
            </AuthProvider>
          </ConfirmProvider>
        </ToastProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;

